export const CAPTCHA_KEY = import.meta.env.VITE_GOOGLE_CAPTCHA_KEY;
export const MARKER_IO_KEY = import.meta.env.VITE_MARKER_IO;
